module.exports = __webpack_public_path__ + "img/bel.27d8ca49.svg";